import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "Routes";
import { Amplify } from "aws-amplify";
import { poolData } from "shared/components/user-pool/AwsConfig";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUser, UserState } from "explorer/reducers/users";
import { autenticado } from "shared/helpers/auth-functions";
import { getGeneros, getGenerosSpotify } from "explorer/reducers/generos";
import { loadUserId } from "shared/helpers/browser-id";
import { Tour } from "radar/components";
import { getCountries } from "explorer/reducers/countries";
import { Personify } from "shared/components";
import { getMonitoredData } from "explorer/reducers/monitored-data";
import { getUserDistroToken } from "explorer/reducers/artistas";
import { useLDClient } from "launchdarkly-react-client-sdk";
import initLDUser from "shared/init-functions/init-ld-user";
import initSentry from "shared/init-functions/init-sentry";
import "./App.scss";
import "translation";

Amplify.configure(poolData);
loadUserId();
initSentry();

function App() {
  const dispatch = useDispatch();
  const ldClient = useLDClient();

  const { loggedUser } = useSelector((state: UserState) => state.users);

  useEffect(() => {
    if (autenticado()) {
      dispatch(getLoggedUser());
      dispatch(getGenerosSpotify());
      dispatch(getGeneros());
      dispatch(getCountries());
      dispatch(getMonitoredData());
      dispatch(getUserDistroToken());
    }
  }, [dispatch]);

  useEffect(() => {
    initLDUser(loggedUser, ldClient);
  }, [ldClient, loggedUser]);

  return (
    <Suspense fallback="loading">
      <BrowserRouter>
        <Tour>
          <Personify />

          <Routes />
        </Tour>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
